import { Form, Formik } from "formik";
import React, { useEffect } from "react";
import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";
import { RiSaveFill } from "react-icons/ri";
import { RiCloseLargeFill } from "react-icons/ri";
import { Tooltip as ReactTooltip } from "react-tooltip";
import FormikInput from "../../Formik/FormikInput";
import FormikSelect from "../../Formik/FormikSelect";

const AddressComponent = ({
  theme,
  countriesOption,
  statesOption,
  getStates,
  handleCreateAddress,
  newCheckoutFormInitialValues,
  newCheckoutFormValidationSchema,
  isAddAddress,
  setIsAddAddress,
}) => {
  const location = useLocation();
  const { country_id } = newCheckoutFormInitialValues;

  useEffect(() => {
    if (country_id) {
      const selectedCountry = countriesOption.find(
        (country) => country.value === country_id
      );

      if (selectedCountry) {
        // setFieldValue("phone_prefix", selectedCountry.phone_code || "968");
        getStates(selectedCountry.value);
      }
    }
  }, [country_id, countriesOption]);

  return (
    <>
      <Formik
        initialValues={{ ...newCheckoutFormInitialValues }}
        validationSchema={newCheckoutFormValidationSchema}
        onSubmit={(values) => handleCreateAddress(values)}
      >
        {({ setFieldValue }) => (
          <Form>
            <ContactInfoTitle>
              {isAddAddress ? (
                "Shipping Address"
              ) : (
                <>
                  2. Add New Address |{" "}
                  <StyledButton
                    theme={theme}
                    to="/signin"
                    state={{ from: location.pathname }}
                  >
                    Sign In
                  </StyledButton>
                </>
              )}
            </ContactInfoTitle>
            <div className="row">
              <AddressField
                name="name"
                placeholder="Name"
                tooltipContent="Enter full name"
              />

              <div className="my-3 col-md-6 col-12 d-flex">
                <FormikInput
                  name="phone_prefix"
                  inputClassName="shipping-phone-prefix"
                  readOnly
                />
                <div className="d-flex flex-column w-100">
                  <FormikInput
                    name="phone"
                    placeholder="Phone"
                    style={{
                      backgroundColor: "#fff",
                      minHeight: "58px",
                      borderRadius: "0.15rem",
                    }}
                    data-tooltip-id="phoneTooltip"
                    data-tooltip-content="Phone number"
                  />
                  <ReactTooltip id="phoneTooltip" type="dark" effect="solid" />
                </div>
              </div>

              <AddressField
                name="email"
                placeholder="Email"
                tooltipContent="Your email address"
              />
              {/* {!isAddAddress && (
                <AddressField
                  name="company_name"
                  placeholder="Company"
                  tooltipContent="Company"
                />
              )} */}
              <AddressField
                name="street"
                placeholder="Street"
                tooltipContent="Street address"
              />
              <AddressField
                name="city"
                placeholder="City"
                tooltipContent="City name"
              />

              <div className="my-3 col-md-6 col-12">
                <FormikSelect
                  name="state_id"
                  borderStyle={true}
                  onChange={(option) => setFieldValue("zip", option.zip || "")}
                  options={statesOption}
                  placeholder="State"
                />
              </div>

              <AddressField
                disabled={true}
                name="zip"
                placeholder="ZIP Code"
                tooltipContent="Postal code"
              />

              <div className="my-3 col-md-6 col-12">
                <FormikSelect
                  name="country_id"
                  borderStyle={true}
                  onChange={(option) => {
                    setFieldValue("phone_prefix", option.phone_code || "968");
                    getStates(option.value);
                  }}
                  options={countriesOption}
                  placeholder="Country"
                />
              </div>
            </div>

            <div className="d-flex gap-2 mt-3">
              <button
                type="submit"
                className="d-flex justify-content-center align-items-center"
                style={{
                  background: theme.primaryColor.secondary,
                  color: theme.primaryColor.primary,
                  cursor: "pointer",
                  borderRadius: "0.15rem",
                  fontFamily: "Outfit, sans-serif",
                  minHeight: "58px",
                  padding: "0 20px",
                }}
              >
                <RiSaveFill className="mx-1" /> Save address
              </button>
              <button
                type="button"
                className="d-flex justify-content-center align-items-center"
                onClick={() => {
                  setIsAddAddress(false);
                }}
                style={{
                  background: "transparent",
                  color: `${theme.primaryColor.primary}`,
                  border: `1px solid ${theme.primaryColor.primary}`,
                  borderRadius: "0.15rem",
                  fontFamily: "Outfit, sans-serif",
                  minHeight: "58px",
                }}
              >
                <RiCloseLargeFill className="mx-1" />
                Cancel
              </button>
            </div>
          </Form>
        )}
      </Formik>
      {/* )} */}
    </>
  );
};

const AddressField = ({
  name,
  placeholder,
  disabled = false,
  tooltipContent,
}) => (
  <div className="my-3 col-md-6 col-12">
    <FormikInput
      name={name}
      disabled={disabled}
      placeholder={placeholder}
      style={{
        backgroundColor: "#fff",
        minHeight: "58px",
        borderRadius: "0.15rem",
      }}
      data-tooltip-id={`${name}Tooltip`}
      data-tooltip-content={tooltipContent}
    />
    <ReactTooltip id={`${name}Tooltip`} type="dark" effect="solid" />
  </div>
);

export default AddressComponent;

const StyledButton = styled(Link)`
  font-family: Outfit, sans-serif;
  text-decoration: none;
  font-weight: bold;
  padding: 10px;
  font-size: 20px;
  color: ${({ theme }) => theme.primaryColor.primary};
  &:hover {
    color: ${({ theme }) => theme.primaryColor.secondary};
  }
  @media (max-width: 375px) {
    font-size: 12px;
  }
`;

const ContactInfoTitle = styled.div`
  font-family: Outfit, sans-serif;
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  font-weight: bold;
  padding: 10px;
  font-size: 20px;
  border-bottom: 2px solid #9c9a9a;
  color: #666666;
  @media (max-width: 375px) {
    font-size: 16px;
  }
`;
